const footerLinks = [
  {
    title: '影视分类',
    items: ['动作电影', '喜剧电影', '科幻电影', '爱情电影', '悬疑电影'],
  },
  {
    title: '剧集频道',
    items: ['国产剧', '韩剧', '美剧', '日剧', '港剧'],
  },
  {
    title: '其他内容',
    items: ['热门综艺', '热血动漫', '纪录片', '专题合集', '排行榜'],
  },
  {
    title: '关于我们',
    items: ['关于90影院', '联系我们', '常见问题', '影片求档'],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200 border-t border-background-300/40">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="font-heading text-2xl font-bold text-primary-500 whitespace-nowrap">
              90影院
            </a>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              8090后最爱的免费高清影视平台。海量片源，每日更新，极速播放不缓冲，打开即看无需注册。
            </p>
          </div>

          {footerLinks.map((group, idx) => (
            <div key={idx}>
              <h4 className="font-heading text-sm font-bold text-foreground-800 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.items.map((item, i) => (
                  <li key={i}>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-300/40">
          <div className="mb-6">
            <h4 className="font-heading text-sm font-bold text-foreground-800 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-400">诚邀优质影视内容合作伙伴，携手共建更好的观影平台</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2024 90影院 | 8090影院免费在线观看不缓冲全集，高清电影电视剧综艺动漫免费看 | 仅供学习交流，请支持正版
            </p>
            <div className="flex items-center gap-4">
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">用户协议</a>
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}